import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TArticleContentLinkClickEventParams } from './_types';

export const articleContentLinkClickEvent = (
  params: TArticleContentLinkClickEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.IN_ARTICLE_ON_LINK_CLICK,
    params,
  });
};
